module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Change your e-mail address","action":"Change e-mail"},"da":{"title":"Rediger din e-mail addresse","action":"Skift e-mail"}}')
  delete Component.options._Ctor
}
